// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"c4c751a3","223":"ceae815a","599":"ceae815a","774":"ceae815a","926":"b009861b"}[chunkId] + ".css";
};